import { getToken } from '../../api/autenticacao.servico'
import { getCategoriasDoAssociado } from '../../api/associado.servico'
import { CATEGORIA_BOOKSTER, CATEGORIAS_CLUBE_NORMAL } from '../../constants'

export const getPayloadToken = () => {
  const token = getToken()
  if ( !token ) {
    return null
  }

  try {
    const [ , payloadBase64 ] = token.split( '.' )
    if ( !payloadBase64 ) {
      return null
    }

    const payloadNormalizado = payloadBase64.replace( /-/gu, '+' ).replace( /_/gu, '/' )
    const payloadDecodificado = decodeURIComponent( escape( window.atob( payloadNormalizado ) ) )

    return JSON.parse( payloadDecodificado )
  } catch ( erro ) {
    return null
  }
}

export const getIdAssociadoDoToken = () => {
  const payload = getPayloadToken()
  const id = payload && payload.associado && payload.associado.id

  return id ? id : null
}

export const getCategoriasDoToken = () => {
  const payload = getPayloadToken()
  const assinaturas = payload && payload.associado && payload.associado.assinaturas

  if ( !assinaturas || !assinaturas.length ) {
    return []
  }

  return assinaturas
    .map( assinatura => assinatura.categoria )
    .filter( Boolean )
    .map( categoria => categoria.toUpperCase() )
}

export const temBookster = categorias => Boolean( categorias ) && categorias.includes( CATEGORIA_BOOKSTER.nome )

export const temBooksterNoToken = () => temBookster( getCategoriasDoToken() )

export const temAssinaturaClubeNormal = () => {
  const categorias = getCategoriasDoToken()

  return CATEGORIAS_CLUBE_NORMAL.some( categoria => categorias.includes( categoria ) )
}

const cacheCategorias = {
  'categorias': null,
  'idAssociado': null,
  'promessa': null
}

export const limparCacheCategorias = () => {
  cacheCategorias.categorias = null
  cacheCategorias.idAssociado = null
  cacheCategorias.promessa = null
}

export const getCategoriasResolvidas = () => {
  const categoriasDoToken = getCategoriasDoToken()

  if ( temBookster( categoriasDoToken ) ) {
    return categoriasDoToken
  }

  if ( cacheCategorias.categorias && cacheCategorias.idAssociado === getIdAssociadoDoToken() ) {
    return cacheCategorias.categorias
  }

  return null
}

export const resolverCategorias = () => {
  const jaResolvidas = getCategoriasResolvidas()
  if ( jaResolvidas ) {
    return Promise.resolve( jaResolvidas )
  }

  const idAssociado = getIdAssociadoDoToken()
  if ( !idAssociado ) {
    return Promise.resolve( getCategoriasDoToken() )
  }

  if ( !cacheCategorias.promessa ) {
    cacheCategorias.promessa = getCategoriasDoAssociado()
      .then( resposta => {
        const categorias = ( ( resposta && resposta.data && resposta.data.categorias ) || [] )
          .filter( Boolean )
          .map( categoria => categoria.toUpperCase() )

        cacheCategorias.categorias = categorias
        cacheCategorias.idAssociado = idAssociado

        return categorias
      } )
      .catch( () => {
        cacheCategorias.promessa = null

        return getCategoriasDoToken()
      } )
  }

  return cacheCategorias.promessa
}
